import { _ as _assign, b as __awaiter, c as __generator } from '../../tslib.es6-604585c1.js';
import ReCaptchaActionOptions from '../constants/index.js';
import { grantType, X_APP_AUTHORIZATION, RequestHeaders, API_URL, SOCIAL_REQUEST_HEADER_TOKEN, LANGUAGE_HEADER_KEY } from '../../configs/constants/index.js';
import IS_BROWSER from '../../isBrowser/index.js';
import isDev from '../../isDev/index.js';
import extractUserInfo from '../../profile/index.js';
import getReCaptchaToken from '../../getReCaptchaToken/index.js';
import getDeviceId from '../../getDeviceId/index.js';
import HttpService from '../http/index.js';

var DEFAULT_BASE_PATH = '/';
var constructAuthHeaderValue = function constructAuthHeaderValue(token) {
  return "".concat(grantType, " ").concat(token);
};
var authorizationHeader = function authorizationHeader(accessToken, tokenHeader) {
  var _a;
  var header = _assign({
    platform: 'website'
  }, X_APP_AUTHORIZATION ? (_a = {}, _a[RequestHeaders.xAppAuthorizationToken] = X_APP_AUTHORIZATION, _a) : {});
  if (accessToken) {
    header[RequestHeaders.authorization] = constructAuthHeaderValue(accessToken);
  }
  if (tokenHeader) {
    header[RequestHeaders.authorization] = tokenHeader;
  }
  return header;
};
var AuthService = function () {
  function AuthService() {}
  AuthService.prototype.signIn = function (username, password, recaptchaToken, preventReCaptcha, currentLanguage) {
    return __awaiter(this, void 0, void 0, function () {
      var headers, signinResponse, userInfo, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            headers = _assign({
              platform: 'website',
              'g-recaptcha-token': recaptchaToken,
              'g-recaptcha-action': 'signIn',
              token: SOCIAL_REQUEST_HEADER_TOKEN
            }, getDeviceId() && {
              deviceid: getDeviceId()
            });
            if (preventReCaptcha) {
              headers[LANGUAGE_HEADER_KEY] = currentLanguage;
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 4,, 5]);
            return [4, HttpService.post("".concat(API_URL, "/user-account/signin.json"), {
              username: username,
              password: password,
              recaptchaToken: recaptchaToken,
              isLocal: isDev
            }, {
              headers: headers
            })];
          case 2:
            signinResponse = _a.sent();
            return [4, extractUserInfo(_assign(_assign({}, signinResponse), {
              registered: false
            }))];
          case 3:
            userInfo = _a.sent();
            return [2, _assign(_assign({}, signinResponse), {
              status: signinResponse.status,
              user: userInfo,
              removal_info: signinResponse.removal_info
            })];
          case 4:
            err_1 = _a.sent();
            console.error('err', err_1);
            return [3, 5];
          case 5:
            return [2];
        }
      });
    });
  };
  AuthService.prototype.signUp = function (email, password, recaptchaToken, hasConsent) {
    return __awaiter(this, void 0, void 0, function () {
      var headers, signupResponse, userInfo;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            headers = {
              platform: 'website',
              'g-recaptcha-token': recaptchaToken,
              'g-recaptcha-action': 'signUp',
              token: SOCIAL_REQUEST_HEADER_TOKEN
            };
            return [4, HttpService.post("".concat(API_URL, "/user-account/signup.json"), {
              email: email,
              password: password,
              isLocal: isDev,
              recaptchaToken: recaptchaToken,
              email_subscription_consent: hasConsent
            }, {
              headers: headers
            })];
          case 1:
            signupResponse = _a.sent();
            return [4, extractUserInfo(_assign(_assign({}, signupResponse), {
              registered: true
            }))];
          case 2:
            userInfo = _a.sent();
            return [2, _assign(_assign({}, signupResponse), {
              status: signupResponse.status,
              user: userInfo,
              removal_info: signupResponse.removal_info
            })];
        }
      });
    });
  };
  AuthService.prototype.updateUsername = function (username, basePath) {
    if (basePath === void 0) {
      basePath = DEFAULT_BASE_PATH;
    }
    return HttpService.post("".concat(basePath, "update-username"), {
      username: username
    });
  };
  AuthService.prototype.validateUsername = function (username, basePath) {
    if (basePath === void 0) {
      basePath = DEFAULT_BASE_PATH;
    }
    return HttpService.post("".concat(basePath, "validate-username"), {
      username: username
    });
  };
  AuthService.prototype.fetchUser = function (accessToken, options, basePath) {
    if (basePath === void 0) {
      basePath = DEFAULT_BASE_PATH;
    }
    var _a = (options || {}).headers,
      headers = _a === void 0 ? {} : _a;
    return HttpService.get("".concat(basePath, "user"), _assign({
      headers: headers
    }, authorizationHeader(accessToken)));
  };
  AuthService.prototype.fetchAppleUser = function (data, basePath) {
    if (basePath === void 0) {
      basePath = DEFAULT_BASE_PATH;
    }
    return HttpService.post(basePath, data);
  };
  AuthService.prototype.sendConfirmationEmail = function (user, email, basePath) {
    if (basePath === void 0) {
      basePath = DEFAULT_BASE_PATH;
    }
    return HttpService.post("".concat(basePath, "send-confirmation-email"), {
      user: user,
      email: email,
      confirmation_email_redirect_url: window.location.href
    });
  };
  AuthService.prototype.setUserTemporaryCookies = function (created, userId) {
    if (IS_BROWSER) {
      var expires = new Date(Date.parse(created) + 24 * 60 * 60 * 1000);
      document.cookie = "user_temporary_".concat(userId, "=user_temporary_").concat(userId, "; expires=").concat(expires);
      document.cookie = "forcedExperimentVariant=1; expires=".concat(expires);
      return true;
    }
    return false;
  };
  AuthService.prototype.extractTemporaryUserInfo = function (userInfo) {
    if (!userInfo) {
      return {};
    }
    var id = userInfo.id,
      created = userInfo.created;
    return {
      created: created,
      id: id
    };
  };
  AuthService.prototype.userStatusCheck = function (userInfo) {
    if (!userInfo) {
      return false;
    }
    var isUserTemporary = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.account_type) === 'temporary';
    if (isUserTemporary) {
      var _a = this.extractTemporaryUserInfo(userInfo),
        id = _a.id,
        created = _a.created;
      id && created && this.setUserTemporaryCookies(created, id);
    }
    return isUserTemporary;
  };
  AuthService.prototype.resendEmailRequest = function (_a) {
    var email = _a.email,
      accessToken = _a.accessToken;
    var body = email ? {
      email: email
    } : {};
    return getReCaptchaToken(ReCaptchaActionOptions.ResendEmailRequest).then(function (_a) {
      var status = _a.status,
        token = _a.token;
      return status === 'success' && HttpService.get("".concat(API_URL, "/user-account/activation?confirmation_email_redirect_url=").concat(window.location.href), _assign(_assign({}, body), {
        headers: _assign(_assign({
          'g-recaptcha-token': token,
          'g-recaptcha-action': ReCaptchaActionOptions.ResendEmailRequest
        }, authorizationHeader(accessToken)), {
          platform: 'website'
        })
      }));
    });
  };
  AuthService.prototype.checkUserExistence = function (email) {
    return __awaiter(this, void 0, void 0, function () {
      var encodedEmail, res, err_2, reason;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            encodedEmail = encodeURIComponent(email.toLowerCase());
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4, getReCaptchaToken(ReCaptchaActionOptions.UserExistence).then(function (_a) {
              var status = _a.status,
                token = _a.token;
              if (status === 'success') {
                return HttpService.get("".concat(API_URL, "/users/email/existence?email_encoded=1&emails=").concat(encodedEmail), {
                  headers: {
                    'g-recaptcha-token': token,
                    'g-recaptcha-action': ReCaptchaActionOptions.UserExistence,
                    platform: 'website'
                  }
                });
              }
            })];
          case 2:
            res = _a.sent();
            return [2, _assign(_assign({}, res), {
              status: res.status
            })];
          case 3:
            err_2 = _a.sent();
            reason = '';
            if (err_2.message === 'Failed to fetch') {
              reason = 'Internet Connection';
            }
            return [2, {
              status: 'error',
              response: err_2,
              reason: reason
            }];
          case 4:
            return [2];
        }
      });
    });
  };
  AuthService.prototype.checkUsernameExistence = function (username) {
    return __awaiter(this, void 0, void 0, function () {
      var res, err_3, reason;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, getReCaptchaToken(ReCaptchaActionOptions.UsernameExistence).then(function (_a) {
              var status = _a.status,
                token = _a.token;
              if (status === 'success') {
                return HttpService.post("".concat(API_URL, "/users/validate/username"), {
                  headers: {
                    'g-recaptcha-token': token,
                    'g-recaptcha-action': ReCaptchaActionOptions.UsernameExistence
                  },
                  username: username.toLowerCase()
                });
              }
            })];
          case 1:
            res = _a.sent();
            return [2, _assign({}, res)];
          case 2:
            err_3 = _a.sent();
            reason = '';
            if (err_3.message === 'Failed to fetch') {
              reason = 'Internet Connection';
            }
            return [2, {
              status: 'error',
              response: err_3,
              reason: reason
            }];
          case 3:
            return [2];
        }
      });
    });
  };
  return AuthService;
}();
var authService = new AuthService();
var setUserTemporaryCookies = authService.setUserTemporaryCookies,
  extractTemporaryUserInfo = authService.extractTemporaryUserInfo,
  userStatusCheck = authService.userStatusCheck,
  resendEmailRequest = authService.resendEmailRequest,
  signIn = authService.signIn,
  signUp = authService.signUp,
  fetchUser = authService.fetchUser,
  fetchAppleUser = authService.fetchAppleUser,
  sendConfirmationEmail = authService.sendConfirmationEmail,
  updateUsername = authService.updateUsername,
  validateUsername = authService.validateUsername,
  checkUserExistence = authService.checkUserExistence,
  checkUsernameExistence = authService.checkUsernameExistence;

export { AuthService, authService, authorizationHeader, checkUserExistence, checkUsernameExistence, constructAuthHeaderValue, extractTemporaryUserInfo, fetchAppleUser, fetchUser, resendEmailRequest, sendConfirmationEmail, setUserTemporaryCookies, signIn, signUp, updateUsername, userStatusCheck, validateUsername };
//# sourceMappingURL=index.js.map
